import React from 'react';
import * as Styled from './GridStyles';
import { GridProps } from './GridTypes';

function Grid({ children, item, ...rest }: GridProps) {
  return item ? (
    <Styled.Col {...rest}>{children}</Styled.Col>
  ) : (
    <Styled.Row {...rest}>{children}</Styled.Row>
  );
}

export default Grid;
